/* unplugin-vue-components disabled */import script from "./Setting.vue?vue&type=script&setup=true&lang=ts"
export * from "./Setting.vue?vue&type=script&setup=true&lang=ts"

import "./Setting.vue?vue&type=style&index=0&id=08fb7229&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fb7229"]])

export default __exports__